import { useState } from "react";
import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const clean = (v) => v.toLowerCase().replace(/[^a-z0-9-]/g, "-").replace(/-+/g, "-").slice(0, 40);

export const SlugEditor = ({ slug, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(slug);
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/biz/staff-app/slug", { slug: value.replace(/^-|-$/g, "") });
      onSaved(data);
      setEditing(false);
      toast.success("Link updated. The old link and QR code still work");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };
  if (!editing) return (
    <Button size="sm" variant="ghost" className="rounded-full" onClick={() => { setValue(slug); setEditing(true); }} data-testid="staff-app-edit-slug-btn">
      <Pencil className="mr-1 h-4 w-4" />Change link name
    </Button>
  );
  return (
    <div className="w-full space-y-2" data-testid="staff-app-slug-editor">
      <div className="flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 font-mono text-sm">
        <span className="shrink-0 text-slate-400">{window.location.host}/join/</span>
        <Input value={value} onChange={(e) => setValue(clean(e.target.value))} className="border-0 px-0 font-mono shadow-none focus-visible:ring-0" data-testid="staff-app-slug-input" autoFocus />
      </div>
      <p className="text-xs text-slate-500">Lowercase letters, numbers and dashes. Old links and printed QR codes keep working.</p>
      <div className="flex gap-2">
        <Button size="sm" className="rounded-full" disabled={saving || value.length < 3} onClick={save} data-testid="staff-app-slug-save-btn">{saving ? "Saving…" : "Save link"}</Button>
        <Button size="sm" variant="ghost" onClick={() => setEditing(false)} data-testid="staff-app-slug-cancel-btn">Cancel</Button>
      </div>
    </div>
  );
};
